/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {LayoutComponent} from './layout.component';
import {AppHeaderComponent} from './app-header/app-header.component';
import {AppSidebarComponent} from './app-sidebar/app-sidebar.component';
import {AppFooterComponent} from './app-footer/app-footer.component';

@NgModule({
  declarations: [
    LayoutComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppFooterComponent
  ],

  exports: [
    LayoutComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    AppFooterComponent
  ],
  imports: [
    RouterModule
  ]
})
export class LayoutModule {
}
